export const DEFAULT_POLL_INTERVAL_SECONDS = 300

export class AnnouncementPoller {
    constructor(handlers = {}) {
        this.handlers = handlers
        this.intervalSeconds = DEFAULT_POLL_INTERVAL_SECONDS
    }

    receive(response) {
        const interval = response?.meta?.interval
        if (typeof interval === 'number') {
            this.intervalSeconds = interval
        }

        const type = response?.data?.type
        if (type == null) {
            return
        }

        this.handlers[type]?.(response.data.payload)
    }
}
